(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function slug(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function viewOf(media) {
    var hay = ((media.alt || "") + " " + (media.path || "") + " " + (media.src || "")).toLowerCase();
    if (hay.indexOf("folded") !== -1 || hay.indexOf("pack") !== -1) return "folded";
    if (hay.indexOf("on-model") !== -1 || hay.indexOf("lifestyle") !== -1) return "lifestyle";
    var views = ["back", "left", "right", "side", "detail", "closeup", "model", "front"];
    for (var i = 0; i < views.length; i++) {
      if (hay.indexOf(views[i]) !== -1) return views[i] === "model" ? "lifestyle" : views[i];
    }
    return "front";
  }

  function fileHay(media) {
    var path = String(media.path || media.src || "");
    var base = path.split("?")[0].split("#")[0];
    var slash = base.lastIndexOf("/");
    if (slash !== -1) base = base.slice(slash + 1);
    return slug((media.alt || "") + " " + base);
  }

  function colorHitsHay(haySlug, colorName) {
    var wrapped = "-" + haySlug + "-";
    var s = slug(colorName);
    if (!s || s.length < 3) return false;
    if (wrapped.indexOf("-" + s + "-") !== -1) return s.length;
    var stripped = s.replace(/^(solid|heather|athletic)-/, "");
    if (stripped !== s && stripped.length >= 4 && wrapped.indexOf("-" + stripped + "-") !== -1) {
      return stripped.length;
    }
    return 0;
  }

  function longestColorMatch(media, colors) {
    var hay = fileHay(media);
    var best = "";
    var bestLen = 0;
    for (var i = 0; i < colors.length; i++) {
      var n = colorHitsHay(hay, colors[i]);
      if (n > bestLen) {
        best = colors[i];
        bestLen = n;
      }
    }
    return best;
  }

  function fileName(url) {
    var path = decodeURIComponent(String(url || "").split("?")[0].split("#")[0]);
    var slash = path.lastIndexOf("/");
    return (slash === -1 ? path : path.slice(slash + 1)).toLowerCase();
  }

  function fileTokens(file) {
    return (
      String(file || "").toLowerCase().match(
        /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g
      ) || []
    );
  }

  function fileAllowed(file, allowed) {
    if (!allowed || !allowed.length) return false;
    var fn = fileName(file);
    var tokens = fileTokens(fn);
    for (var i = 0; i < allowed.length; i++) {
      var al = fileName(allowed[i]);
      if (!al) continue;
      if (fn === al) return true;
      var stem = al.replace(/\.[a-z0-9]+$/i, "");
      if (stem && fn.indexOf(stem.toLowerCase()) !== -1) return true;
      var at = fileTokens(al);
      for (var j = 0; j < at.length; j++) {
        if (tokens.indexOf(at[j]) !== -1) return true;
      }
    }
    return false;
  }

  function isLifestyleFile(file) {
    return /_2048\.jpe?g$/i.test(fileName(file));
  }

  function printifyKeys(url) {
    var base = fileName(url).replace(/\.[a-z0-9]+$/i, "");
    var keys = [];
    var seen = {};
    function add(k) {
      k = String(k || "").toLowerCase();
      if (!k || seen[k]) return;
      seen[k] = true;
      keys.push(k);
    }
    var full = base.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g) || [];
    full.forEach(add);
    var short = base.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}/g) || [];
    short.forEach(add);
    var pair = base.match(/[0-9a-f]{8}-[0-9a-f]{4}/g) || [];
    pair.forEach(add);
    return keys;
  }

  function groupMedia(payload, variants) {
    var colors = payload.colors || [];
    var media = (payload.media || []).map(function (item, index) {
      var src = item.src || "";
      var path = item.path || src;
      return {
        id: String(item.id || ""),
        imageId: String(item.imageId || item.id || ""),
        src: src,
        alt: item.alt || "",
        path: path,
        file: fileName(path || src),
        attached: !!item.attached,
        index: index,
        colors: [],
        featured: false,
        view: viewOf(item),
      };
    });

    var featuredByKey = {};
    function addFeatured(id, color) {
      if (!id || !color) return;
      var key = String(id);
      featuredByKey[key] = featuredByKey[key] || [];
      if (featuredByKey[key].indexOf(color) === -1) featuredByKey[key].push(color);
    }
    variants.forEach(function (variant) {
      addFeatured(variant.featuredMediaId, variant.color);
      addFeatured(variant.featuredImageId, variant.color);
      addFeatured(fileName(variant.image), variant.color);
    });

    function featuredColors(item) {
      var keys = [item.id, item.imageId, item.file];
      var out = [];
      keys.forEach(function (k) {
        (featuredByKey[k] || []).forEach(function (c) {
          if (out.indexOf(c) === -1) out.push(c);
        });
      });
      return out;
    }

    media.forEach(function (item) {
      var featured = featuredColors(item);
      if (featured.length) {
        item.featured = true;
        item.colors = featured.slice();
      }
    });

    media.forEach(function (item) {
      if (item.colors.length) return;
      var match = longestColorMatch(item, colors);
      if (match) item.colors.push(match);
    });

    var keyToColors = {};
    media.forEach(function (item) {
      if (!item.featured) return;
      printifyKeys(item.path || item.src).forEach(function (k) {
        keyToColors[k] = keyToColors[k] || [];
        item.colors.forEach(function (c) {
          if (keyToColors[k].indexOf(c) === -1) keyToColors[k].push(c);
        });
      });
    });
    media.forEach(function (item) {
      if (item.colors.length) return;
      var keys = printifyKeys(item.path || item.src);
      var best = "";
      var bestLen = 0;
      keys.forEach(function (k) {
        var cols = keyToColors[k];
        if (cols && cols.length === 1 && k.length >= bestLen) {
          best = cols[0];
          bestLen = k.length;
        }
      });
      if (best) item.colors.push(best);
    });

    var n = colors.length;
    var m = media.length;
    if (n > 1 && m >= n && m % n === 0) {
      var vpp = m / n;
      var colorMajor = vpp > 0;
      for (var c = 0; c < n && colorMajor; c++) {
        var lead = media[c * vpp];
        if (!lead || !lead.featured) colorMajor = false;
        else if (lead.colors.indexOf(colors[c]) === -1) colorMajor = false;
      }
      if (colorMajor) {
        media.forEach(function (item, i) {
          var col = colors[Math.floor(i / vpp)];
          if (!col || item.featured) return;
          if (item.colors.indexOf(col) === -1) item.colors.push(col);
        });
      }
    }

    // Printify 3-up publish: variant fronts first, then extra mockups grouped by color
    // [front0..frontN-1, model0, folded0, model1, folded1, ...]
    if (n > 1 && m > n && (m - n) % n === 0) {
      var headsOk = true;
      for (var hi = 0; hi < n && headsOk; hi++) {
        if (!media[hi].featured || media[hi].colors.indexOf(colors[hi]) === -1) headsOk = false;
      }
      if (headsOk) {
        var extrasPerColor = (m - n) / n;
        media.forEach(function (item, i) {
          if (i < n || item.featured || item.colors.length) return;
          var col = colors[Math.floor((i - n) / extrasPerColor)];
          if (col && item.colors.indexOf(col) === -1) item.colors.push(col);
        });
      }
    }

    // Color-major Shopify/Printify media: extras sitting between two featured
    // images belong to the featured color on the left.
    // [WhiteFront, WhiteBack, WhiteLeft, BlackFront, BlackBack, ...]
    var featAt = [];
    media.forEach(function (item, i) {
      if (item.featured) featAt.push(i);
    });
    if (featAt.length) {
      for (var f = 0; f < featAt.length; f++) {
        var a = featAt[f];
        var b = f + 1 < featAt.length ? featAt[f + 1] : media.length;
        var col = media[a].colors[0];
        if (!col) continue;
        if (f === featAt.length - 1) {
          var extraCount = b - a - 1;
          var run = 1;
          for (var r = featAt.length - 2; r >= 0; r--) {
            if (featAt[r] === featAt[r + 1] - 1) run += 1;
            else break;
          }
          if (run >= 3 && extraCount > 2) continue;
        }
        for (var i = a + 1; i < b; i++) {
          if (media[i].featured || media[i].colors.length) continue;
          media[i].colors.push(col);
        }
      }
    }

    var untagged = media.filter(function (item) {
      return !item.colors.length;
    });
    if (untagged.length && n && untagged.length % n === 0) {
      untagged.forEach(function (item, k) {
        var col = colors[k % n];
        if (col) item.colors.push(col);
      });
    }

    return media;
  }

  function sortMedia(list) {
    var order = ["front", "back"];
    return list.slice().sort(function (a, b) {
      var ai = order.indexOf(a.view);
      var bi = order.indexOf(b.view);
      if (ai === -1) ai = 99;
      if (bi === -1) bi = 99;
      if (ai !== bi) return ai - bi;
      return a.index - b.index;
    });
  }

  function initMenu() {
    var openBtn = document.querySelector("[data-menu-open]");
    var menu = document.getElementById("mobile-menu");
    if (!openBtn || !menu) return;
    var close = function () {
      menu.classList.remove("open");
    };
    openBtn.addEventListener("click", function () {
      menu.classList.add("open");
    });
    menu.querySelectorAll("[data-menu-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
  }

  function initCards() {
    document.querySelectorAll("[data-swatch]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var card = btn.closest("[data-product-card]");
        var img = card && card.querySelector("[data-card-image]");
        var src = btn.getAttribute("data-image");
        if (img && src) img.setAttribute("src", src);
      });
    });
  }

  function initProduct() {
    var root = document.querySelector("[data-product-section]");
    var form =
      document.querySelector("form[data-product-form]") ||
      (root && root.querySelector("form")) ||
      document.querySelector("[data-product-form]");
    if (!form) return;
    var select = form.querySelector("[data-variant-select]");
    if (!select) return;
    var main = document.querySelector("[data-product-main]");
    var price = document.querySelector("[data-product-price]");
    var add = form.querySelector("[data-add]");
    var colorLabel = form.querySelector("[data-color-label]");
    var sizeLabel = form.querySelector("[data-size-label]");
    var thumbsWrap = document.querySelector("[data-thumbs]");
    var payloadNode = document.querySelector("[data-media-payload]");
    var payload = { colors: [], media: [] };
    if (payloadNode) {
      try {
        payload = JSON.parse(payloadNode.textContent);
      } catch (err) {
        payload = { colors: [], media: [] };
      }
    }

    function options() {
      return Array.from(select.options)
        .map(function (opt) {
          return {
            el: opt,
            id: opt.value,
            color: (opt.getAttribute("data-color") || "").trim(),
            size: (opt.getAttribute("data-size") || "").trim(),
            available: opt.getAttribute("data-available") !== "false" && !opt.disabled,
            image: opt.getAttribute("data-image") || "",
            price: opt.getAttribute("data-price") || "",
            featuredMediaId: (opt.getAttribute("data-featured-media") || "").trim(),
            featuredImageId: (opt.getAttribute("data-featured-image") || "").trim(),
          };
        })
        .filter(function (variant) {
          return variant.id;
        });
    }

    var grouped = groupMedia(payload, options());

    function selectedButtons() {
      var colorBtn = form.querySelector(".evx-color.is-selected");
      var sizeBtn = form.querySelector(".evx-size.is-selected");
      return {
        color: colorBtn ? colorBtn.getAttribute("data-value") : "",
        size: sizeBtn ? sizeBtn.getAttribute("data-value") : "",
      };
    }

    function find(color, size) {
      var list = options();
      return (
        list.find(function (variant) {
          return variant.color === color && variant.size === size;
        }) ||
        list.find(function (variant) {
          return variant.color === color && variant.available;
        }) ||
        list.find(function (variant) {
          return variant.color === color;
        })
      );
    }

    function mediaForColor(color) {
      if (!color) return [];
      var assets = payload.assetGalleries && payload.assetGalleries[color];
      if (assets && assets.length) {
        return sortMedia(
          assets.map(function (item, i) {
            return {
              id: "asset-" + color + "-" + (item.view || i),
              imageId: "asset-" + color + "-" + (item.view || i),
              src: item.src,
              file: fileName(item.src),
              view: item.view || (i === 0 ? "front" : "back"),
              index: i,
              colors: [color],
            };
          }),
        );
      }
      var handle = payload.handle || "";
      var map = (typeof window !== "undefined" && window.EVOMAX_GALLERY_MAP) || {};
      var allowed = map[handle] && map[handle][color];
      var list;
      if (allowed && allowed.length) {
        list = grouped.filter(function (item) {
          if (isLifestyleFile(item.file || item.src || item.path)) return false;
          return fileAllowed(item.file || item.src || item.path, allowed);
        });
        list.forEach(function (item) {
          var idx = -1;
          for (var i = 0; i < allowed.length; i++) {
            if (fileAllowed(item.file || item.src || item.path, [allowed[i]])) {
              idx = i;
              break;
            }
          }
          item.view = idx <= 0 ? "front" : "back";
        });
      } else {
        list = grouped.filter(function (item) {
          if (isLifestyleFile(item.file || item.src || item.path)) return false;
          if (item.view === "detail" || item.view === "closeup") return false;
          return item.colors.indexOf(color) !== -1;
        });
      }
      var extraSrc = payload.assetBacks && payload.assetBacks[color];
      if (extraSrc) {
        var already = list.some(function (item) {
          return item.src === extraSrc || item.file === fileName(extraSrc);
        });
        if (!already) {
          list.push({
            id: "asset-back-" + color,
            imageId: "asset-back-" + color,
            src: extraSrc,
            file: fileName(extraSrc),
            view: "back",
            index: 999,
            colors: [color],
          });
        }
      }
      if (list.length) return sortMedia(list);
      return [];
    }

    function showGallery(color, featuredSrc) {
      if (!thumbsWrap) return featuredSrc;
      var list = mediaForColor(color);
      if (!list.length && featuredSrc) {
        var fallback = grouped.find(function (item) {
          return item.src === featuredSrc;
        });
        if (fallback) list = [fallback];
      }
      var buttons = Array.prototype.slice.call(thumbsWrap.querySelectorAll("[data-thumb]"));
      var firstSrc = "";
      buttons.forEach(function (btn) {
        var id = String(btn.getAttribute("data-media-id") || "");
        var imageId = String(btn.getAttribute("data-image-id") || "");
        var file = fileName(btn.getAttribute("data-src") || "");
        var match = list.find(function (item) {
          return (
            item.id === id ||
            item.imageId === imageId ||
            item.imageId === id ||
            item.file === file ||
            item.src === (btn.getAttribute("data-src") || "")
          );
        });
        if (!match && btn.getAttribute("data-color") === color && (btn.hasAttribute("data-asset-back") || btn.hasAttribute("data-asset-gallery"))) {
          match = list.find(function (item) {
            return item.src === (btn.getAttribute("data-src") || "") || item.file === file;
          });
        }
        if (!match) {
          btn.hidden = true;
          btn.classList.remove("is-active");
          return;
        }
        btn.hidden = false;
        if (!firstSrc) firstSrc = match.src || btn.getAttribute("data-src");
      });
      var shown = list.map(function (item) {
        return item.src;
      });
      var nextSrc =
        featuredSrc && shown.indexOf(featuredSrc) !== -1 ? featuredSrc : firstSrc || featuredSrc;
      buttons.forEach(function (btn) {
        var src = btn.getAttribute("data-src");
        btn.classList.toggle("is-active", !!nextSrc && src === nextSrc);
      });
      thumbsWrap.classList.toggle("is-single", list.length <= 1);
      return nextSrc;
    }

    function apply(variant, keepSrc) {
      if (!variant) return;
      select.value = variant.id;
      if (colorLabel) colorLabel.textContent = variant.color;
      if (sizeLabel) sizeLabel.textContent = variant.size;
      if (price && variant.price) price.textContent = variant.price;
      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available ? "Add to bag" : "Sold out";
      }
      form.querySelectorAll(".evx-size").forEach(function (btn) {
        var match = options().find(function (item) {
          return item.color === variant.color && item.size === btn.getAttribute("data-value");
        });
        btn.classList.toggle("is-unavailable", !match || !match.available);
      });
      var gallerySrc = showGallery(variant.color, variant.image || keepSrc || "");
      var nextImage = variant.image || gallerySrc;
      if (main && nextImage) main.setAttribute("src", nextImage);
    }

    form.addEventListener("click", function (event) {
      var colorBtn = event.target.closest(".evx-color");
      var sizeBtn = event.target.closest(".evx-size");
      if (colorBtn) {
        event.preventDefault();
        form.querySelectorAll(".evx-color").forEach(function (btn) {
          btn.classList.remove("is-selected");
        });
        colorBtn.classList.add("is-selected");
        var cur = selectedButtons();
        apply(find(cur.color, cur.size));
      }
      if (sizeBtn && !sizeBtn.classList.contains("is-unavailable")) {
        event.preventDefault();
        form.querySelectorAll(".evx-size").forEach(function (btn) {
          btn.classList.remove("is-selected");
        });
        sizeBtn.classList.add("is-selected");
        var cur2 = selectedButtons();
        apply(find(cur2.color, cur2.size), main ? main.getAttribute("src") : "");
      }
    });

    if (thumbsWrap) {
      thumbsWrap.addEventListener("click", function (event) {
        var btn = event.target.closest("[data-thumb]");
        if (!btn || btn.hidden) return;
        event.preventDefault();
        var src = btn.getAttribute("data-src");
        if (main && src) main.setAttribute("src", src);
        thumbsWrap.querySelectorAll("[data-thumb]").forEach(function (el) {
          el.classList.toggle("is-active", el === btn);
        });
      });
    }

    var initial = find(selectedButtons().color, selectedButtons().size) || options()[0];
    apply(initial);
  }

  function stripShopifyPolicyLabel() {
    var path = String(window.location.pathname || "").toLowerCase();
    var wanted = "";
    if (path.indexOf("privacy") !== -1) wanted = "Privacy";
    else if (path.indexOf("terms") !== -1) wanted = "Terms";
    else if (path.indexOf("refund") !== -1 || path.indexOf("shipping") !== -1) wanted = "Shipping and Refunds";

    document.querySelectorAll(".shopify-policy__title, .shopify-policy__title h1").forEach(function (el) {
      var t = String(el.textContent || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
      if (t === "privacy policy") el.textContent = "Privacy";
      else if (t === "terms of service") el.textContent = "Terms";
      else if (t === "refund policy" || t === "shipping policy") el.textContent = "Shipping and Refunds";
      el.classList.add("page-title");
    });

    if (wanted && !document.querySelector("#MainContent .page-title")) {
      var main = document.getElementById("MainContent");
      if (!main) return;
      var wrap = main.querySelector(".wrap") || main.querySelector(".shopify-policy__container") || main;
      var h = document.createElement("h1");
      h.className = "page-title";
      h.textContent = wanted;
      wrap.insertBefore(h, wrap.firstChild);
    }

    var titles = document.querySelectorAll("#MainContent .page-title");
    if (titles.length > 1) {
      var seen = {};
      Array.prototype.slice.call(titles).forEach(function (el) {
        var key = String(el.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
        if (seen[key]) el.remove();
        else seen[key] = true;
      });
    }
  }

  function initShippingPage() {
    var path = String(window.location.pathname || "").toLowerCase();
    if (path.indexOf("shipping") === -1 && path.indexOf("refund") === -1 && path.indexOf("return") === -1) return;
    var main = document.getElementById("MainContent");
    var tpl = document.getElementById("evx-shipping-page");
    if (!main) return;
    var text = String(main.textContent || "").toLowerCase();
    if (tpl && (text.indexOf("not found") !== -1 || text.indexOf("does not exist") !== -1)) {
      main.innerHTML = tpl.innerHTML;
    }
    document.title = "Shipping and Refunds";
    stripShopifyPolicyLabel();
  }

  ready(function () {
    initMenu();
    initCards();
    initProduct();
    initShippingPage();
    stripShopifyPolicyLabel();
  });
})();
